import * as React from "react";
import type { SVGProps } from "react";
const SvgDashboard6 = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 3.75A3.25 3.25 0 0 0 3.75 7v10A3.25 3.25 0 0 0 7 20.25h.25V3.75zm1.75 0v3.5h11.5V7A3.25 3.25 0 0 0 17 3.75zm11.5 5H8.75v11.5H17A3.25 3.25 0 0 0 20.25 17zM2.25 7A4.75 4.75 0 0 1 7 2.25h10A4.75 4.75 0 0 1 21.75 7v10A4.75 4.75 0 0 1 17 21.75H7A4.75 4.75 0 0 1 2.25 17z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDashboard6;
